import React from 'react';


const Info = () => {

    return <div className="info">
        <h3>Инфо</h3>
           Наша цель — делиться знаниями, поэтому мы публикуем только книги с открытым доступом. Если вы заметили ошибку или ваши права были затронуты, дайте нам знать — мы исправим ситуацию!
        <h3>Контакты</h3>   
            Email: help@text-library.ru
           
    </div>;

}

export default Info;